<template>
  <div style="padding: 15px">
    <el-form ref="form" :model="form" :rules="rules" label-width="120px">
      <el-form-item label="车辆牌照号" prop="licenseNumber">
        <el-autocomplete
          v-model="form.licenseNumber"
          :fetch-suggestions="
            (queryString, cb) =>
              querySearchAsync(queryString, cb, 'licenseNumber')
          "
          placeholder="请输入车辆牌照号"
          :clearable="true"
          :disabled="true"
          @select="handleSelect"
        />
      </el-form-item>
      <el-form-item label="实际承运人" prop="driverName">
        <el-autocomplete
          v-model.trim="form.driverName"
          :fetch-suggestions="
            (queryString, cb) => querySearchAsync(queryString, cb, 'driverName')
          "
          placeholder="请选择实际承运人"
          :clearable="true"
          :disabled="true"
          @select="handleSelect"
        />
      </el-form-item>
      <el-form-item label="事故时间" prop="accidentTime">
        <el-date-picker
          v-model="form.accidentTime"
          type="date"
          placeholder="请选择事故时间"
          value-format="yyyy-MM-dd"
        />
      </el-form-item>
      <el-form-item label="事故地点" prop="violationPlace">
        <el-input v-model="form.violationPlace" placeholder="请输入事故地点" />
      </el-form-item>
      <el-form-item label="事故原因" prop="violationProject">
        <el-input
          v-model="form.violationProject"
          placeholder="请输入事故原因"
        />
      </el-form-item>
      <el-form-item label="责任方" prop="responsibleParty">
        <el-input v-model="form.responsibleParty" placeholder="请输入责任方" />
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input v-model="form.remark" placeholder="请输入备注" />
      </el-form-item>
      <el-form-item>
        <el-button @click="funcCancel">取 消</el-button>
        <el-button type="primary" @click="funcSubmit">确 定</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import {
  vehicleAccidentCode,
  updateVehicleAccident
} from "@/api/vehicleService";
import { validateCarNum } from "@/utils/validate.js";
export default {
  props: {
    restaurants: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      form: {},
      rules: {
        licenseNumber: [
          {
            required: true,
            validator(rule, value, callback) {
              validateCarNum(value)
                ? callback()
                : callback(new Error("请输入正确的车辆牌照号"));
            },
            trigger: "blur"
          }
        ],
        driverName: [
          { required: true, message: "请输入实际承运人", trigger: "change" }
        ],
        accidentTime: [
          { required: true, message: "请选择事故时间", trigger: "blur" }
        ],
        violationPlace: [
          { required: true, message: "请输入事故地点", trigger: "blur" },
          { max: 255, message: "长度为255个字符" }
        ],
        violationProject: [
          { required: true, message: "请输入事故原因", trigger: "blur" },
          { max: 255, message: "长度为255个字符" }
        ],
        responsibleParty: [
          { required: true, message: "请输入责任方", trigger: "blur" },
          { max: 256, message: "长度为256个字符" }
        ],
        remark: [
          { required: true, message: "请输入备注", trigger: "blur" },
          { max: 1000, message: "长度为1000个字符" }
        ]
      }
    };
  },
  methods: {
    getInfo(code) {
      this.$refs.form.resetFields();
      vehicleAccidentCode(code).then(response => {
        this.form = response.data;
        this.form.code = code;
      });
    },
    // 提交
    funcSubmit() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          const rLoading = this.openLoading();
          updateVehicleAccident(this.form).then(response => {
            rLoading.close();
            this.$message({ message: response.msg, type: "success" });
            this.$emit("hideModel", true);
          });
        } else {
          return false;
        }
      });
    },
    // 取消
    funcCancel() {
      this.$emit("hideModel", false);
    },
    /**
     * 模糊查询
     * 车牌号/实际承运人
     */
    querySearchAsync(queryString, cb, word) {
      var temArr1 = this.filterList(queryString, word);
      temArr1.forEach(item => {
        item.value = item[word];
      });
      cb(temArr1);
    },
    filterList(queryString, word) {
      var list = this.restaurants.filter(item => {
        if (item[word]) {
          return item[word].indexOf(queryString) > -1;
        }
      });
      return list;
    },
    handleSelect(item) {
      this.form.vehicleCode = item.code;
      this.form.driverCode = item.partyCode;
      this.form.driverName = item.driverName;
      this.form.licenseNumber = item.licenseNumber;
    }
  }
};
</script>
<style lang="scss" scoped>
.el-date-editor {
  width: 100%;
}
.el-autocomplete {
  width: 100%;
}
</style>
